<i [attr.data-feather]="icon" width="70%"></i>
